export default __webpack_public_path__ + "static/media/PaymentWeb.f7125cb6.png";